import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";

export default function ClubCancel() {
  const [params] = useSearchParams();
  const token = params.get("t") || "";
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setErr("Ce lien est incomplet. Réouvre-le depuis ton email."); return; }
    api.get(`/mailclub/cancel-info?t=${encodeURIComponent(token)}`).then(r => setInfo(r.data)).catch(e => setErr(e.response?.data?.detail || "Lien expiré ou invalide."));
  }, [token]);

  async function cancel() {
    setBusy(true);
    try {
      const r = await api.post("/mailclub/cancel", { token });
      setDone(r.data);
    } catch (e) { setErr(e.response?.data?.detail || "Impossible de résilier pour le moment."); } finally { setBusy(false); }
  }

  const fmt = d => d ? new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : null;

  return (
    <div data-testid="club-cancel-page" className="max-w-xl mx-auto px-6 py-16 md:py-24 fade-in">
      <p className="font-hand text-xl text-[#A3876A] mb-2">Le Club de Lettres</p>
      {err && <><h1 className="font-serif text-3xl mb-4">Oups.</h1><p data-testid="club-cancel-error" className="text-[#A86962]">{err}</p>
        <p className="text-sm text-[#7C7064] mt-6">Tu peux aussi m'écrire depuis la <Link to="/contact" className="underline">page contact</Link>, je m'en occupe.</p></>}
      {!err && info && !done && (
        <>
          <h1 className="font-serif text-3xl md:text-4xl mb-4">Tu souhaites arrêter ton abonnement{info.first_name ? `, ${info.first_name}` : ""} ?</h1>
          {info.status === "cancel_scheduled" || info.status === "canceled" ? (
            <p data-testid="club-cancel-already" className="text-[#4A4036]">C'est déjà fait : aucun prélèvement ne suivra{info.current_period_end && <> et ta période payée court jusqu'au <strong>{fmt(info.current_period_end)}</strong></>}.</p>
          ) : (
            <>
              <p className="text-[#4A4036] leading-relaxed mb-3">Aucune justification à donner. En confirmant, les prochains prélèvements s'arrêtent.</p>
              <ul className="text-sm text-[#4A4036] space-y-1 mb-8 bg-[#F5F0E6] border border-[#E8DCC8] p-4">
                {info.current_period_end && <li>• Ta période déjà réglée court jusqu'au <strong>{fmt(info.current_period_end)}</strong>.</li>}
                {info.last_envelope_month && <li>• Tu recevras encore l'enveloppe de <strong>{info.last_envelope_month}</strong>, déjà réglée.</li>}
                <li>• Tu pourras revenir quand tu veux, le club reste ouvert.</li>
              </ul>
              <button data-testid="club-cancel-confirm" onClick={cancel} disabled={busy} className="btn-primary w-full sm:w-auto">{busy ? "…" : "Je confirme la résiliation"}</button>
              <Link to="/club-de-lettres" className="block mt-4 text-sm text-[#7C7064] hover:underline">Finalement, je reste</Link>
            </>
          )}
        </>
      )}
      {done && (
        <div data-testid="club-cancel-done">
          <h1 className="font-serif text-3xl md:text-4xl mb-4">C'est noté, merci pour ce bout de chemin.</h1>
          <p className="text-[#4A4036] leading-relaxed">Ta résiliation est confirmée : aucun prélèvement ne suivra.{done.cancel_at_period_end && <> Ta période payée court jusqu'au <strong>{fmt(done.cancel_at_period_end)}</strong>.</>} Un email de confirmation vient de t'être envoyé.</p>
          <p className="font-hand text-2xl text-[#A3876A] mt-8">— Amélie</p>
        </div>
      )}
      {!err && !info && !done && <p className="text-[#7C7064]">Un instant…</p>}
    </div>
  );
}
